import { render, staticRenderFns } from "./customer-edit-dialog.vue?vue&type=template&id=6ba03f06&scoped=true"
import script from "./customer-edit-dialog.vue?vue&type=script&lang=js"
export * from "./customer-edit-dialog.vue?vue&type=script&lang=js"
import style0 from "./customer-edit-dialog.vue?vue&type=style&index=0&id=6ba03f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba03f06",
  null
  
)

export default component.exports